/* Tooltips invert: --color-text background with --color-text-inverse (≥ 14:1 in every theme). */
.popup {
  max-inline-size: var(--tooltip-max);
  padding: var(--space-1) var(--space-2);
  border-radius: var(--radius-md);
  background: var(--color-text);
  color: var(--color-text-inverse);
  font-size: var(--text-xs);
  line-height: var(--leading-normal);
  overflow-wrap: anywhere;
  transform-origin: var(--transform-origin);
  transition:
    opacity var(--duration-normal) var(--easing-standard),
    transform var(--duration-normal) var(--easing-standard);
}

.popup[data-starting-style],
.popup[data-ending-style] {
  opacity: 0;
  transform: scale(var(--motion-scale));
}

.popup[data-instant] {
  transition-duration: 0ms;
}
